import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SitePublicService} from 'src/app/services/site-public.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {DirectorsDialogComponent} from '../../dialogs/directors-dialog/directors-dialog.component';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {DirectorsPeriodDialogComponent} from '../../dialogs/directors-period-dialog/directors-period-dialog.component';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-directors',
  templateUrl: './directors.component.html',
  styleUrls: [ './directors.component.scss' ]
})
export class DirectorsComponent implements OnInit, OnDestroy {

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'period', 'edit', 'manage', 'delete' ];

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  private subscription: Subscription | undefined;

  constructor (
    private _sitePublicService: SitePublicService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,) {

    /*
    if (!this._authService.isAdmin) {
    this.router.navigate([ 'home' ]);
    }
    */

    this.loadData()
  }

  ngOnInit () {
  }

  ngOnDestroy () {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async loadDirectors () {
    const waiting = this._spinnerService.show();
    const array: any = await this._sitePublicService.selectBienniums();
    this.dataSource = new MatTableDataSource(array);
    this.dataSource.sort = this.sort;
    waiting.close()
  }

  loadData () {

    const waiting = this._spinnerService.show();

    // 1. Chama o serviço que retorna o Observable
    const statute$ = this._sitePublicService.selectBienniums();

    // 2. Se inscreve no Observable
    this.subscription = statute$.subscribe({
      next: (array: any[]) => {
        // Este código será executado na primeira vez E em cada mudança subsequente.
        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;
        // O 'waiting.close()' deve ser feito apenas na primeira vez.
        // Uma forma simples é verificar se o spinner está aberto ou usar 'finalize' no pipe.
        // apenas fechar, assumindo que já está aberto.
        if (waiting) {
          waiting.close();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar dados: ', error);
        if (waiting) {
          waiting.close();
        }
        // Trate o erro (ex: exibir mensagem para o usuário)
      },
      // O complete não é chamado, pois é um Observable "infinito" (tempo real)
    });
  }


  openPeriodDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'period': ''}
    }

    let dialogRef = this.dialog.open(DirectorsPeriodDialogComponent, {
      width: '600px',
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });


    dialogRef.afterClosed()
      .subscribe(async (response) => {
        console.log("-------------------------------------------")
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const formData = form.getRawValue();


        if (actionType == 'insert') {

          console.log("insert: " + JSON.stringify(formData));
          await this._sitePublicService.insertBiennium(formData)
            .then(async () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao adicionar bienio")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });
        } else {
          console.log("update: " + JSON.stringify(formData));
          await this._sitePublicService.updateBiennium(formData)
            .then(async () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao atualizar bienio")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });
        }
      })

  }

  openDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'period': ''}
    }

    let dialogRef = this.dialog.open(DirectorsDialogComponent, {
      width: '500px',
      height: '200px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const formData = form.getRawValue();

        if (actionType == 'insert') {
          // console.log("insert: " + JSON.stringify(formData))
          this._sitePublicService.insertBiennium(formData)
            .then(() => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              this._snackBar.openSnackBar("Erro!", '', 'error')
            })
        } else if (actionType == 'update') {
          //console.log("update: " + JSON.stringify(formData))
          this._sitePublicService.updateBiennium(formData)
            .then(() => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro: " + err.message)
              this._snackBar.openSnackBar("Erro!", '', 'error')
            })
        }

      })

  }


  delete (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.period + "<br><br>Excluir este período?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._sitePublicService.deleteBiennium(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete gestão error: " + error.message)}
          )
      }
    })
  }

}
